import React, { useState } from 'react'
import styled from 'styled-components'
import SearchGrower from '../../knisot/Create/Components/SearchGrower'
import { IGrowerItem } from '../../../../../modules/API/Defaults/models/growers'
import ControlButton from '../../../../../generic/buttons/ControlButton'

type Props = {
  growerList: IGrowerItem[]
  selectedGrowerID: number
  onGrowerSelect: (growerID: number) => void
  closeFunc: () => void
}

const GrowerSelectorModal = ({
  growerList,
  selectedGrowerID,
  onGrowerSelect,
  closeFunc
}: Props) => {
  const [growerID, setGrowerID] = useState<number>(selectedGrowerID)

  const handleSave = () => {
    onGrowerSelect(growerID)
    closeFunc()
  }

  return (
    <ModalWrapper>
      <SearchGrower
        list={growerList}
        defaultID={growerID}
        setGrowerID={setGrowerID}
        placeholder="בחר מגדל"
        required={!growerID}
      />
      <ButtonWrapper>
        <ControlButton
          lable="ביטול"
          handleClick={closeFunc}
        />
        <ControlButton
          lable="שמור"
          handleClick={handleSave}
        />
      </ButtonWrapper>
    </ModalWrapper>
  )
}

const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 1em;
`

const ButtonWrapper = styled.div`
  display: flex;
  gap: 0.5em;
  justify-content: center;
  margin-top: auto;
`

export default GrowerSelectorModal 